module.exports = __webpack_public_path__ + "static/media/loc1_img27.05ad860d.jpg";